var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"watermark-container"},[_c('div',{staticClass:"watermark-content"},_vm._l((100),function(item){return _c('div',{key:item,staticClass:"watermark-text"},[_c('div',[_vm._v(_vm._s(_vm.content))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }